import { FC, MouseEvent, useContext, useRef, useState } from "react";
import { Link } from "react-router-dom";
import NotificationDispatch, { showErrorNotification } from "../../../context/notificationContext";
import useI18n from "../../../hooks/useTranslations";
import { ListItemWithQuantity } from "../../../http/types/items";
import { useItemsApi } from "../../../http/useItems";
import SvgExcel from "../../icons/Excel";
import ItemDialog from "../../items/ItemDialog";
import Button from "../../ui/Button";
import FlexContent from "../../ui/FlexContent";
import SubmitBar from "../../ui/SubmitBar";
import Table from "../../ui/Table";

interface VertigripItemsListProps {
  configurationId: string;
  isAdmin?: boolean;
  back: () => void;
}

const VertigripItemsList: FC<VertigripItemsListProps> = ({
  configurationId,
  isAdmin,
  back,
}: VertigripItemsListProps) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const [selectedItem, setSelectedItem] = useState<ListItemWithQuantity | null>(null);
  const itemsApi = useItemsApi();
  const { data, error } = itemsApi.getConfigurationItemsList(configurationId, aborter.current.signal);

  const openItemDialog = (item: ListItemWithQuantity) => setSelectedItem(item);

  const closeItemDislog = () => setSelectedItem(null);

  const handleCodeClick =
    (item: ListItemWithQuantity) =>
    (event: MouseEvent<HTMLAnchorElement>): void => {
      event.preventDefault();
      event.stopPropagation();
      openItemDialog(item);
    };

  return (
    <FlexContent padding noPaddingTop>
      <Table<ListItemWithQuantity>
        head={
          <tr>
            <th align="left">{i18n.translation.common.code}</th>
            <th align="left">{i18n.translation.common.description}</th>
            <th align="right">{i18n.translation.common.qty}</th>
            <th align="right">{i18n.translation.common.minOrderQuantity}</th>
          </tr>
        }
        items={data}
        renderRow={(item) => (
          <>
            <td>
              <Link to={`${isAdmin ? "/admin" : ""}/items/${item.id}`} onClick={handleCodeClick(item)}>
                {item.code}
              </Link>
            </td>
            <td>{item.description}</td>
            <td align="right">{item.quantity}</td>
            <td align="right">{item.minOrderQuantity}</td>
          </>
        )}
        onRowClick={(item) => openItemDialog(item)}
        error={!!error}
      />
      <SubmitBar>
        <Button
          buttonProps={{
            disabled: !data || !!error,
            onClick: back,
          }}
          type="secondary"
        >
          {i18n.translation.common.back}
        </Button>
        <Button
          glyph={SvgExcel}
          buttonProps={{
            disabled: !data || !!error,
            onClick: () =>
              itemsApi
                .downloadEServiceExportConfigurationItemsList(configurationId)
                .catch((err) => dispatch(showErrorNotification(i18n, err))),
          }}
        >
          {i18n.translation.common.excel}
        </Button>
      </SubmitBar>
      {selectedItem && <ItemDialog item={selectedItem} onClose={closeItemDislog} />}
    </FlexContent>
  );
};

export default VertigripItemsList;
